export default {
    SCOPE_CONFIG: 32,
    SCOPE_GLOBAL: 16,
    SCOPE_PARTNER: 8,
    SCOPE_REGION: 4,
    SCOPE_TIMESLOT: 2,
    SCOPE_RESERVATION: 1,
}
